
<template>
  <div ref="showTExt" class="compare" style="width: 80%; max-width: 1200px; margin: 50px auto">
    <div style="text-align: center; margin-bottom: 29px">
      <span class="Header_line" style="margin-right: 20px"></span>
      <span
        style="
          font-size: 40px;
          font-family: 'Source Han Sans CN';
          font-weight: bold;
        "
      >优势对比</span>
      <span class="Header_line" style="margin-left: 20px"></span>
    </div>
    <div class="compare-info">
      <div
        class="compare-left"
        v-show="show0"
        :class="show0 ? 'animate__animated animate__bounceInLeft' : ''"
      >
        <div class="compare-data">
          <div class="compare-header">
            <img src="@/assets/compare-left.png" alt />
          </div>
          <div class="compare-content">
            <div
              class="compare-all"
              v-show="show3"
              :class="show3 ? 'animate__animated animate__backInDown' : ''"
            >
              <img src="@/assets/compare-1.png" alt />
              <span class="compare-txt">点击仓库名，一键智能查价，降低20%时间成本</span>
            </div>
            <div
              class="compare-all"
              v-show="show3"
              :class="show3 ? 'animate__animated animate__backInDown' : ''"
            >
              <img src="@/assets/compare-1.png" alt />
              <span class="compare-txt">一键查询货物轨迹，承运疑问7*24小时在线服务</span>
            </div>
            <div
              class="compare-all"
              v-show="show3"
              :class="show3 ? 'animate__animated animate__backInDown' : ''"
            >
              <img src="@/assets/compare-1.png" alt />
              <span class="compare-txt">价格透明，小卖家一件也是协议价，高效清关派送</span>
            </div>
            <div
              class="compare-all"
              v-show="show3"
              :class="show3 ? 'animate__animated animate__backInDown' : ''"
            >
              <img src="@/assets/compare-1.png" alt />
              <span class="compare-txt">一键下单，坐等免费上门揽收，节省30%人力成本</span>
            </div>
            <div
              class="compare-all"
              v-show="show3"
              :class="show3 ? 'animate__animated animate__backInDown' : ''"
            >
              <img src="@/assets/compare-1.png" alt />
              <span class="compare-txt">申请赔付12小时内受理，3个工作日内答复</span>
            </div>
          </div>
        </div>
      </div>
      <img
        class="imgs"
        v-show="show2"
        :class="show2 ? 'animate__animated animate__bounceInDown' : ''"
        src="@/assets/compare-vs.png"
        alt
      />
      <div
        class="compare-right"
        v-show="show0"
        :class="show1 ? 'animate__animated animate__bounceInRight' : ''"
      >
        <div class="compare-data">
          <div class="compare-header">
            <img src="@/assets/compare-right.png" alt />
            <span class="compare-h1" style="font-size:24px">传统货代</span>
          </div>
          <div class="compare-content compare-content-1">
            <div
              class="compare-all"
              v-show="show3"
              :class="show3 ? 'animate__animated animate__backInDown' : ''"
            >
              <img src="@/assets/compare-2.png" alt />
              <span class="compare-txt-1">Excel表价格时效更新慢，查价繁琐耗时高</span>
            </div>
            <div
              class="compare-all"
              v-show="show3"
              :class="show3 ? 'animate__animated animate__backInDown' : ''"
            >
              <img src="@/assets/compare-2.png" alt />
              <span class="compare-txt-1">货物轨迹、承运问题，答非所问、互相推诿</span>
            </div>
            <div
              class="compare-all"
              v-show="show3"
              :class="show3 ? 'animate__animated animate__backInDown' : ''"
            >
              <img src="@/assets/compare-2.png" alt />
              <span class="compare-txt-1">下单后甲方秒变乙方，价格时效无保障</span>
            </div>
            <div
              class="compare-all"
              v-show="show3"
              :class="show3 ? 'animate__animated animate__backInDown' : ''"
            >
              <img src="@/assets/compare-2.png" alt />
              <span class="compare-txt-1">小件少件自行送到快递点，上门需额外收费</span>
            </div>
            <div
              class="compare-all"
              v-show="show3"
              :class="show3 ? 'animate__animated animate__backInDown' : ''"
            >
              <img src="@/assets/compare-2.png" alt />
              <span class="compare-txt-1">丢件延时、承诺理赔过程长，到账通通无期</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentScroll: 0,
      show0: false,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
    }
  },
  created () { },
  mounted () {
    window.addEventListener("scroll", this.getScroll)
  },
  destroyed () {
    window.removeEventListener("scroll", this.getScroll)
  },
  methods: {
    getScroll () {
      this.currentScroll = window.pageYOffset
      if (this.currentScroll - this.$refs.showTExt.offsetTop >= 40) {
        this.show0 = true
        this.show1 = true
        this.show4 = true
        this.show5 = true
        let that = this
        setTimeout(function () {
          that.show3 = true
        }, 500)
        setTimeout(function () {
          that.show2 = true
        }, 1200)
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.compare-info {
  display: flex;
  align-items: center;
  position: relative;
  height: 353px;
}
img.imgs {
  z-index: 999;
  position: absolute;
  left: 45%;
}
.compare-left {
  width: 600px;
  height: 353px;
  background: #FF4D01;
  border-radius: 30px 0px 0px 30px;
  padding: 50px 56px;
  box-sizing: border-box;
  //   margin-right: -40px;
}
.compare-right {
  width: 600px;
  height: 313px;
  background: #f5f5f5;
  border-radius: 0px 30px 30px 0px;
  //   margin-left: -40px;
  padding: 41px 70px;
  box-sizing: border-box;
}
.compare-content {
  margin-top: 10px;
}
.compare-all {
  display: flex;
  align-items: center;
  margin-left: 20px;
  .compare-txt {
    margin-left: 10px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    line-height: 36px;
  }
  .compare-txt:hover {
    text-decoration: underline;
    cursor: pointer;
  }
  .compare-txt-1 {
    margin-left: 10px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #999999;
    line-height: 36px;
  }
  .compare-txt-1:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}
.compare-header {
  display: flex;
  align-items: center;
  span {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #666666;
    margin-left: 15px;
  }
}
.compare-content-1 {
  margin-top: 20px;
}
.Header_line {
  display: inline-block;
  width: 133px;
  border-top: 2px solid #FF4D01;
  vertical-align: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/placeOrder/placeindexInfo/Compare.vue